<template>
    <div class="row">
        <div class="col-lg-12">
            <b-card :header="uLang('app.overview')" header-tag="h4" class="bg-default-card">

                <div>
                    <div class="pull-left">
                        <div class="p-2">
                            <span>{{ lang('app.rows_per_page_text') }} : </span>
                            <select class="rowsPerPageClass" name="rowsPerPage" id="rowsPerPage" v-model="rowsPerPage">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="45">45</option>
                                <option value="60">60</option>
                                <option value="90">90</option>
                            </select>
                        </div>
                    </div>

                    <div class="pull-right mb-3 d-flex flex-row justify-content-between">
                        <div class="p-2 mx-4" style="margin-top: 4px">
                            {{ lang('app.show_archived_action_documents') }}:
                            <toggle-button v-model="showArchivedActionDocuments" color="#5A4587"/>
                        </div>
                        <div class="p-2">
                            <router-link class="btn btn-brand" :to="{ name: 'admin.action-documents.create' }">{{ uLang('app.add_type', { type: lang('app.action_document') }) }}</router-link>
                        </div>
                    </div>
                </div>

                <table-admin-action-document :show-archived-action-documents="showArchivedActionDocuments" :rows-per-page="rowsPerPage" />
            </b-card>
        </div>
    </div>
</template>

<script>
    import TableAdminActionDocument from '~/components/tables/admin/action-document/table'

    export default {
        name: 'index',

        data() {
            return {
                rowsPerPage: "15",
                showArchivedActionDocuments: false
            }
        },

        components: {
            'table-admin-action-document': TableAdminActionDocument,
        },

        methods: {
            create() {
                this.$router.push({ name: 'admin.organisations.create'});
            },
        }
    }
</script>

<style lang="css" scoped>
.rowsPerPageClass {
    display: inline-block;
    width: 100px;
    padding: 6px;
}
</style>